import { Epigraph as Component } from './styled';

export const Epigraph = Component;
